import { createContext, FC, useState } from 'react';

export enum AppVersion {
    V1 = 'v1',
    V2 = 'v2',
}

export type App = {
    version: string;
};

const initialAppState: App = {
    version: AppVersion.V1,
};

export const AppContext = createContext<App>(initialAppState);

export const AppContextProvider: FC = ({ children }) => {
    const [app] = useState<App>(window._app || initialAppState);

    return (
        <AppContext.Provider value={app}>
            {children}
        </AppContext.Provider>
    );
};
